module.exports = __webpack_public_path__ + "img/offers-empty-state.4766fe2a.svg";